/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ContractState = zod
	.object({
		block_reason: zod.string().nullable().describe('Reason the contract is blocked'),
		entitled: zod.boolean().describe('Whether the contract is entitled for usage'),
		id: zod.string().describe('Contract ID'),
		package_key: zod.string().describe('Package key'),
		package_name: zod.string().describe('Package display name'),
		started_at: zod.iso.datetime({ offset: true }).describe('Contract start timestamp'),
		status: zod.enum(['pending', 'active', 'expired'])
	})
	.describe('Active contract state');

export type ContractState = zod.input<typeof ContractState>;
export type ContractStateOutput = zod.output<typeof ContractState>;
